import { render, staticRenderFns } from "./VehiclePropertiesForm.vue?vue&type=template&id=72232c2b&"
import script from "./VehiclePropertiesForm.vue?vue&type=script&lang=js&"
export * from "./VehiclePropertiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72232c2b')) {
      api.createRecord('72232c2b', component.options)
    } else {
      api.reload('72232c2b', component.options)
    }
    module.hot.accept("./VehiclePropertiesForm.vue?vue&type=template&id=72232c2b&", function () {
      api.rerender('72232c2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vehicles/Forms/VehiclePropertiesForm.vue"
export default component.exports